import styled from "styled-components";

export const StyledDiv = styled.div`
  display: flex;
  @media print {
    display: none;
  }
`;

export const StyledSpan = styled.span`
  line-height: 2.2rem;
  padding-right: 10px;
`;
